import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { useLanguage } from '../i18n/LanguageContext';
interface PrivacyPolicyPageProps {
  onNavigate: (page: string) => void;
}
export function PrivacyPolicyPage({
  onNavigate
}: PrivacyPolicyPageProps) {
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-26587">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-26588">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26589">
          <Breadcrumbs items={[{
          label: t('legal.backToHome'),
          onClick: () => onNavigate('home')
        }, {
          label: t('legal.privacy.title')
        }]} className="mb-8" data-id="element-26590" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-26591">
            {t('legal.privacy.title')}
          </h1>
          <p className="text-slate-500" data-id="element-26592">{t('legal.lastUpdated')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-26593">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-26594">
          <h2 data-id="element-26595">{t('legal.privacy.s1.title')}</h2>
          <p data-id="element-26596">{t('legal.privacy.s1.p1')}</p>

          <h2 data-id="element-26597">{t('legal.privacy.s2.title')}</h2>
          <p data-id="element-26598">{t('legal.privacy.s2.p1')}</p>
          <ul data-id="element-26599">
            <li data-id="element-26600">{t('legal.privacy.s2.l1')}</li>
            <li data-id="element-26601">{t('legal.privacy.s2.l2')}</li>
            <li data-id="element-26602">{t('legal.privacy.s2.l3')}</li>
          </ul>

          <h2 data-id="element-26603">{t('legal.privacy.s3.title')}</h2>
          <p data-id="element-26604">{t('legal.privacy.s3.p1')}</p>
          <ul data-id="element-26605">
            <li data-id="element-26606">{t('legal.privacy.s3.l1')}</li>
            <li data-id="element-26607">{t('legal.privacy.s3.l2')}</li>
            <li data-id="element-26608">{t('legal.privacy.s3.l3')}</li>
            <li data-id="element-26609">{t('legal.privacy.s3.l4')}</li>
          </ul>

          <h2 data-id="element-26610">{t('legal.privacy.s4.title')}</h2>
          <p data-id="element-26611">{t('legal.privacy.s4.p1')}</p>

          <h2 data-id="element-26612">{t('legal.privacy.s5.title')}</h2>
          <p data-id="element-26613">{t('legal.privacy.s5.p1')}</p>

          <h2 data-id="element-26614">{t('legal.privacy.s6.title')}</h2>
          <p data-id="element-26615">{t('legal.privacy.s6.p1')}</p>
          <ul data-id="element-26616">
            <li data-id="element-26617">{t('legal.privacy.s6.l1')}</li>
            <li data-id="element-26618">{t('legal.privacy.s6.l2')}</li>
            <li data-id="element-26619">{t('legal.privacy.s6.l3')}</li>
          </ul>

          <h2 data-id="element-26620">{t('legal.privacy.s7.title')}</h2>
          <p data-id="element-26621">{t('legal.privacy.s7.p1')}</p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-26622">
          <button onClick={() => onNavigate('terms')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-26623">
            {t('legal.terms.title')} →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-26624">
            {t('legal.contactUs')}
          </button>
        </div>
      </div>
    </div>;
}